import React, { useContext } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import styles from './styles.module.scss'
import { Municipality as IMunicipality } from 'types/Municipality'
import { percentFormatter } from 'lib/formatters'
import { colorGenerator } from 'lib/colours'
import { LocaleContext } from 'contexts/locale'

export interface ListProps {
  list: IMunicipality[]
  setActiveMunicipalityHandler: (id: string) => void
  isSortedAscending: boolean
  onIncreaseShownLines: (numberOfLines: number) => void
  onFlipSortOrder: () => void
  currentExtents: [number, number]
}

export function List({
  list,
  isSortedAscending,
  onIncreaseShownLines,
  onFlipSortOrder,
  setActiveMunicipalityHandler,
  currentExtents
}: ListProps) {
  let locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')

  return (
    <div className='municipality list'>
      <table
        className='ui small unstackable selectable table'
        onMouseLeave={() => setActiveMunicipalityHandler('-1')}
      >
        <thead>
          <tr>
            <th />
            <th>{messages['municipality']}</th>
            <th className={styles.desktopOnly}>{messages['canton']}</th>
            <th className='right aligned single line'>
              <span className={styles.desktopOnly}>
                {messages['burdenLong']}
              </span>
              <span className={styles.mobileOnly}>
                {messages['burdenShort']}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {list !== undefined &&
            list.map((municipality, index) => {
              return (
                <Municipality
                  currentExtents={currentExtents}
                  key={index}
                  {...municipality}
                  handler={setActiveMunicipalityHandler}
                />
              )
            })}
        </tbody>
      </table>

      <div className='ui vertical small basic labeled icon fluid buttons'>
        <a className='ui button' onClick={() => onIncreaseShownLines(20)}>
          <i className='plus icon' />
          {messages['showMore']}
        </a>
        <a className='ui button' onClick={onFlipSortOrder}>
          <i
            className={`sort content ${
              isSortedAscending ? 'ascending' : 'descending'
            } icon`}
          />
          {messages['sortOrder']}
        </a>
      </div>
    </div>
  )
}

interface MunicipalityRowProps extends IMunicipality {
  handler: (id: string) => void
  currentExtents: [number, number]
}

const Municipality = ({
  Gemeindename,
  Kanton,
  Belastung,
  GemeindeID,
  handler,
  Rank,
  currentExtents
}: MunicipalityRowProps) => {
  let locale = useContext(LocaleContext)

  return (
    <tr onMouseOver={() => handler(GemeindeID.toString())}>
      <td
        className={`center aligned ${styles.rankCell}`}
        style={{
          backgroundColor: colorGenerator(
            (Belastung - currentExtents[0]) /
              (currentExtents[1] - currentExtents[0])
          )
        }}
      >
        {Rank}
      </td>
      <td>{Gemeindename}</td>
      <td className={styles.desktopOnly}>{Kanton}</td>
      <td className='right aligned'>
        {percentFormatter(locale)(Belastung * 0.01)}
      </td>
    </tr>
  )
}

export default List
